// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, children }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={3}
      // Ensure 'palette' and 'typography' are destructured correctly here
      sx={({ palette, typography }) => ({ // Destructure 'palette' and 'typography' from theme
        fontSize: typography.size ? typography.size.sm : "0.875rem", // Fallback if size.sm is undefined
        // Use a fixed pixel value for border width
        borderBottom: noBorder ? "none" : `1px solid ${palette.grey[300]}`,
        borderRight: `1px solid ${palette.grey[300]}`,
        "&:last-child": {
          borderRight: "none",
        },
      })}
    >
      <MDBox
        display="inline-block"
        width="max-content"
        color="white"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;